import React from "react";
import Skeleton from "react-loading-skeleton";
import { useHistory } from "react-router-dom";
import UserProfile from "../../images/avatar-defaul-girls.jpg";
import { url } from "../../utils/url";

export default function NavbarSearchResult({ user, paddingX = false }) {
  const history = useHistory();

  let img_url = user?.image
    ? user?.image
    : url + user?.profile?.url || UserProfile;

  return (
    <div
      className={`flex justify-start items-center cursor-pointer gap-3 w-full my-2 text-muted py-1 sm:px-1 ${
        paddingX ? "md:px-2 " : "px-1"
      }`}
      onClick={() => {
        history.push(`/users/${user.username}`);
      }}
    >
      {user.profile?.url ? (
        <img
          src={img_url}
          alt={`${user.username}'s profile`}
          className="object-cover"
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "50%",
            marginLeft: "0.5rem",
          }}
        />
      ) : (
        <div className="rounded-full" style={{ width: "50px", height: "45px" }}>
          {" "}
          <Skeleton circle={true} width={"100%"} height={"100%"} />
        </div>
      )}
      <div>
        <p className="m-0 font-weight-bold">{user.names}</p>
        <span className="m-0">{user.username}</span>
      </div>
      {user.account_type === "VERIFIED" && (
        <div title="Account verified">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="20"
            height="20"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
              fill="rgba(249,2,2,1)"
            />
          </svg>
        </div>
      )}
    </div>
  );
}
